import { render } from "./TheZone.vue?vue&type=template&id=242b7165"
import script from "./TheZone.vue?vue&type=script&lang=js"
export * from "./TheZone.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__